import { render } from "./ProfileDetailInfor.vue?vue&type=template&id=798716cc&ts=true"
import script from "./ProfileDetailInfor.vue?vue&type=script&lang=ts"
export * from "./ProfileDetailInfor.vue?vue&type=script&lang=ts"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__